import { useContext } from 'react'

import type { GoogleSearchMethods } from '@awaze/mfe-common.api.places-api'
import { PlacesContext, useSuggestions } from '@awaze/mfe-common.api.places-api'

import { formatAutocompleteSubtitle } from '@/components/SearchForm/SearchForm.helper'
import { PlacesSuggestions } from '@/components/SearchForm/SearchForm.types'
import { Assert } from '@/utils/assert'
import { dataLayerErrorHandler } from '@/utils/dataLayerErrorHandler'

export const usePlacesSuggestions = (
  googleSearchMethod: GoogleSearchMethods,
): PlacesSuggestions => {
  const getSuggestions = useSuggestions()
  const { useSuggestionsRestEndpoint } = useContext(PlacesContext)

  return async (searchTerm: string) => {
    try {
      return (await getSuggestions(searchTerm, 100, googleSearchMethod)).map(
        (location) => ({
          ...location,
          subtitle: formatAutocompleteSubtitle(location),
          link: '',
        }),
      )
    } catch (e) {
      Assert.error(e)
      // eslint-disable-next-line no-console
      console.log('Error while calling places', e.message)

      dataLayerErrorHandler(
        e,
        'usePlacesSuggestions: failed to fetch suggestions',
        {
          googleSearchMethod,
          searchTermLength: searchTerm.length,
          useSuggestionsRestEndpoint,
        },
      )

      return []
    }
  }
}
